import type { PricingVersionFormat, PricingVersionTuple } from '../../model/model.ts'

type FrPrelPricingVersionFormat = PricingVersionFormat<'fr-pre-lourmel'>

export const frPrelPricingVersions = [
  ['pricing-fr-pre-lourmel-1.0.0-2026-03-20', { label: 'Version 1' }],
] as const satisfies PricingVersionTuple<FrPrelPricingVersionFormat>[]

export type FrPrelPricingVersion = (typeof frPrelPricingVersions)[number][0]
